const config = {
  name: process.env.NEXT_PUBLIC_APP_NAME,
  domain: process.env.NEXT_PUBLIC_APP_DOMAIN,
  storeName: process.env.NEXT_PUBLIC_STORE_NAME,
  url: process.env.NEXT_PUBLIC_WEB_APP_URL,
  supportCenterUrl: process.env.NEXT_PUBLIC_SUPPORT_CENTER_URL,
  disbursementIncomeCreatorUrl:
    process.env.NEXT_PUBLIC_DISBURSEMENT_INCOME_CREATOR_URL,
  tiptipBrowserSupport: [
    'chrome',
    'firefox',
    'safari',
    'mobile safari',
    'mobile chrome',
    'mobile firefox',
  ],
  publicVersion: process.env.NEXT_PUBLIC_APP_VERSION || '',
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT,
  assetBaseUrl: process.env.NEXT_PUBLIC_ASSET_BASE_URL,
  hideWhitelistedCreatorProductRecap:
    process.env.NEXT_PUBLIC_HIDE_WHITELISTED_CREATOR_PRODUCT_RECAP,
}

export default config
